import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, IconButton, Stack, Tooltip } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import dayjs from "dayjs";

const MonthSelector = ({ selectedMonth, onMonthChange }) => {
    const handlePrevMonth = () => {
        if (selectedMonth) {
            const prev = dayjs(selectedMonth).subtract(1, "month");
            onMonthChange(prev.format("YYYY-MM"));
        }
    };

    const handleNextMonth = () => {
        if (selectedMonth) {
            const next = dayjs(selectedMonth).add(1, "month");
            onMonthChange(next.format("YYYY-MM"));
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                justifyContent="center"
                sx={{ padding: 1.5, borderRadius: 3 }}
            >
                <Tooltip title="Previous Month">
                    <span>
                        <IconButton
                            onClick={handlePrevMonth}
                            disabled={!selectedMonth}
                            sx={{
                                color: "#0A2540",
                                backgroundColor: "rgba(10, 37, 64, 0.08)",
                                borderRadius: "12px",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    backgroundColor: "#00BFA5",
                                    color: "#FFFFFF",
                                    transform: "scale(1.05)"
                                },
                                "&.Mui-disabled": {
                                    opacity: 0.4
                                }
                            }}
                        >
                            <ArrowBackIosNew fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>

                <DatePicker
                    views={["year", "month"]}
                    label="Select a Month"
                    value={selectedMonth ? dayjs(selectedMonth) : null}
                    onChange={(date) =>
                        onMonthChange(date ? dayjs(date).format("YYYY-MM") : "")
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{
                                minWidth: 220,
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 3,
                                    backgroundColor: "#FFFFFF",
                                    "&:hover fieldset": {
                                        borderColor: "#00BFA5"
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#00BFA5"
                                    }
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#00BFA5"
                                }
                            }}
                        />
                    )}
                />

                <Tooltip title="Next Month">
                    <span>
                        <IconButton
                            onClick={handleNextMonth}
                            disabled={!selectedMonth}
                            sx={{
                                color: "#0A2540",
                                backgroundColor: "rgba(10, 37, 64, 0.08)",
                                borderRadius: "12px",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    backgroundColor: "#00BFA5",
                                    color: "#FFFFFF",
                                    transform: "scale(1.05)"
                                },
                                "&.Mui-disabled": {
                                    opacity: 0.4
                                }
                            }}
                        >
                            <ArrowForwardIos fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            </Stack>
        </LocalizationProvider>
    );
};

export default MonthSelector;
